module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAMpJREFUOE9jZCATMOLUt70pAiznWbcCmxo8GhsbIBrrITQaGHIaQQHx7+8BBi6GLwy/mGczsP1NZfjBVAL2Fse/HrjYNwYeBiZmB1CAQfy4vekAAwNjA4Nn7QGG7Y0NDIxMzgwM/05CwoPJnOH/v73gQNre7MDA8L+BwbPOAVMj2CCQZsZqsL7//1vhIUtQI8QVNdB4bIHHBFEasUUeVo2MDBsY/jNewJsCGf8bMPxnCED4cUdjB8N/Rguiki3j/xMMHvUVuFMOAVMA/FFfD5ZhL6cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_down.png
// module id = OTUl
// module chunks = 1